import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useSheshaApplication } from '@shesha-io/reactjs';
import { allComponents } from '../designer';

export interface RslApplicationPluginProps {

}

export const RSL_PLUGIN_NAME = 'rsl-crm';

export const RslApplicationPlugin: FC<PropsWithChildren<RslApplicationPluginProps>> = ({ children }) => {
    const { registerFormDesignerComponents } = useSheshaApplication();

    useEffect(() => {
        registerFormDesignerComponents(RSL_PLUGIN_NAME, allComponents);
    }, []);

    return (
        <>{children}</>
    );
};
